/** @type {"Canvas"} */
export const CANVAS = "Canvas";
/** @type {"Page"} */
export const PAGE = "Page";
/** @type {"Site"} */
export const SITE = "Site";
